// SETTINGS
export const SET_TIME_MULTIPLIER = 'SET_TIME_MULTIPLIER';
export const SET_QUANTITY_MULTIPLIER = 'SET_QUANTITY_MULTIPLIER';
export const SET_RANDOM_SEED = 'SET_RANDOM_SEED';
export const SET_DPR = 'SET_DPR';
export const SET_ANTI_ALIAS = 'SET_ANTI_ALIAS';
export const SET_DEBUG = 'SET_DEBUG';

// CHAPTERS
export const FOCUS_CHAPTER = 'FOCUS_CHAPTER';
export const ADD_CHAPTER = 'ADD_CHAPTER';

// PRESENTATION MODE
export const PRESENTATION_MODE_RANDOM_CYCLE = 'PRESENTATION_MODE_RANDOM_CYCLE';
export const PRESENTATION_MODE_EXPLORE = 'PRESENTATION_MODE_EXPLORE';
export const PRESENTATION_MODE_DEFAULT = PRESENTATION_MODE_RANDOM_CYCLE;
export const SET_PLAYING = 'SET_PLAYING';
export const SET_INIT_COMPLETE = 'SET_INIT_COMPLETE';
export const SET_OPTIONS_OPEN = 'SET_OPTIONS_OPEN';
export const SET_ABOUT_MODAL_OPEN = 'SET_ABOUT_MODAL_OPEN';

// ENVIRONMENTS
export const IMMERSION = 'IMMERSION';
export const ART_WALL = 'ART_WALL';
export const COMMONS = 'COMMONS';
export const VISUALIZATION = 'VISUALIZATION';
export const GAMELAB = 'GAMELAB';

// SLIDES
export const FOCUS_SLIDE = 'FOCUS_SLIDE';
export const NEXT_SLIDE = 'NEXT_SLIDE';
export const PREV_SLIDE = 'PREV_SLIDE';



// WEBPACK FOOTER //
// ./src/constants/Constants.js